export default {
  setToken: (state, token) => {
    localStorage.setItem('token', token);
    state.token = token
  },
  setLoading: (state, loading) => state.loading = loading
}
